import {useFetch} from "../useFetch";
import {vehicleStatusService} from "../../services/guide/vehicleStatus-service";
import {VehicleStatus} from "../../types/api/guide/vehicleStatus.types";

export const useFetchGetVehicleStatusById = (id?: string) => {

    const { isLoading, error, data } =
        useFetch<VehicleStatus>(
            vehicleStatusService.getById,
            [id],
            { enabled: Boolean(id) });

    return { data: data as VehicleStatus, isLoading, error };
}